import React, { useRef } from 'react';

function CrystalPredictionModule({ onSubmit }) {
  const fileRef = useRef();

  const handleSubmit = () => {
    const file = fileRef.current.files[0];
    if (!file) return alert("请上传分子结构文件（.mol2/.sdf/.pdb）");

    const formData = new FormData();
    formData.append('molFile', file);
    onSubmit('晶型预测', formData, 'crystal');
  };

  return (
    <div className="flex flex-col h-full">
      <input type="file" accept=".mol2,.sdf,.pdb" ref={fileRef} className="form-input" />
      <div className="flex justify-center mt-auto pt-4">
        <button onClick={handleSubmit} className="btn-primary">提交任务</button>
      </div>
    </div>
  );
}

export default CrystalPredictionModule;

